/**
 * Der Block „Zähler erkannt" im Dokumentblatt (`document-meter-suggestion`,
 * Spec 46c, „Beide Clients — Dokument-Blatt") — unter der Absender-
 * Vorschlagskarte, nur mit `meter_suggestion`. Dieselbe Bauform wie
 * `SuggestionCard`: ein Hinweis (`role="status"`), den Akzent trägt allein
 * „Übernehmen".
 *
 * Rein präsentational: `DocumentSheet` besitzt die Mutationen und die
 * Fehleranzeige. Kennsatz „Zähler erkannt" ist ein Client-Wort, Zählernummer
 * (`reason_display`) und Ziel (`summary_display`) kommen vom Server.
 */

import type { DocumentMeterSuggestion } from '@/features/documents/api'

interface MeterSuggestionCardProps {
  readonly suggestion: DocumentMeterSuggestion
  readonly onAccept: () => void
  readonly onDismiss: () => void
  readonly isPending: boolean
}

export function MeterSuggestionCard({ suggestion, onAccept, onDismiss, isPending }: MeterSuggestionCardProps) {
  return (
    <div
      data-testid="document-meter-suggestion"
      role="status"
      aria-busy={isPending}
      className="border-border bg-bg rounded-card flex flex-col gap-3 border px-4 py-3 md:flex-row md:items-center md:justify-between"
    >
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="text-label text-muted uppercase">Zähler erkannt</span>
        <span className="text-label text-muted">{suggestion.reason_display}</span>
        <span className="text-body text-text break-words font-(--font-weight-section)">{suggestion.summary_display}</span>
      </div>

      <div className="flex flex-col gap-2 md:flex-row md:shrink-0">
        <button
          type="button"
          data-testid="document-meter-suggestion-accept"
          disabled={isPending}
          aria-busy={isPending}
          onClick={onAccept}
          className="bg-accent rounded-card text-body min-h-(--tap-min) px-4 text-accent-on transition-opacity duration-(--duration-fast) ease-(--ease-out) disabled:opacity-60"
        >
          Übernehmen
        </button>
        <button
          type="button"
          data-testid="document-meter-suggestion-dismiss"
          disabled={isPending}
          aria-busy={isPending}
          onClick={onDismiss}
          className="border-border text-text rounded-card text-body min-h-(--tap-min) border px-4 transition-colors duration-(--duration-fast) ease-(--ease-out) disabled:opacity-60"
        >
          Verwerfen
        </button>
      </div>
    </div>
  )
}
